import React, { useCallback, useState } from 'react';

// CORE COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// LOCAL COMPONENTS
import FormWrapper from '../parts/FormWrapper';

// VARIABLES
const INITIAL_VALUES = {
  initializedSelect: 2,
  initializedCustomSelect: 'foobar',
  initializedMultiSelect: '2,3,foobar',
}
const OPTIONS = [
  {
    label: 'Lorem Ipsum',
    value: 0
  },
  {
    label: 'Dolor Sit Amet',
    value: 1
  },
  {
    label: 'Consectetur',
    value: 2
  },
  {
    label: 'Adipiscing',
    value: 3
  }
]

// eslint-disable-next-line no-unused-vars
const GROUPED_OPTIONS = [
  {
    label: 'Group 1',
    options: [
      OPTIONS[0],
      OPTIONS[1]
    ]
  },
  {
    label: 'Group 2',
    options: [
      OPTIONS[2],
      OPTIONS[3]
    ]
  },
]

// MAIN COMPONENT
const FormElements = () => {

  const [ options, setOptions ] = useState();
  const loadOptions = useCallback(
    () => setOptions(OPTIONS),
    [setOptions]
  )

  // RENDER
  return (
    <FormWrapper
      initialValues={INITIAL_VALUES}
    >
      <Form.Select
        name="select"
        label="Select"
        options={OPTIONS}
        //options={GROUPED_OPTIONS}
        //useNone
        //useAll
        required
        selectProps={{
          //prefix: 'Prefix'
        }}
        //size="sm"
        //plaintext
        //menuIsOpen
      />
      <Form.Select
        name="initializedSelect"
        label="Select (initialized value)"
        options={OPTIONS}
        required
      />
      <Form.Select
        name="defaultSelect"
        label="Select (default value)"
        options={OPTIONS}
        useDefault
        required
      />
      <Form.Select
        name="customSelect"
        label="Custom Select"
        options={OPTIONS}
        allowCustom
        required
      />
      <Form.Select
        name="initializedCustomSelect"
        label="Custom Select (initialized value)"
        options={OPTIONS}
        allowCustom
        required
      />
      <Form.Select
        name="defaultCustomSelect"
        label="Custom Select (default value)"
        options={OPTIONS}
        allowCustom
        useDefault
        required
      />
      <Form.Select
        name="loadingCustomSelect"
        label="Custom Select (loading)"
        options={options}
        allowCustom
        required
      />
      <Form.Control
        label=" "
        as={() => (
          <Button
            label="Load Options"
            onClick={loadOptions}
          />
        )}
      />
      <Form.Select
        name="multiSelect"
        label="Multi-Select"
        options={OPTIONS}
        multiple
        //useNone
        //useAll
        required
      />
      <Form.Select
        name="customMultiSelect"
        label="Custom Multi-Select"
        options={OPTIONS}
        multiple
        allowCustom
        required
      />
      <Form.Select
        name="initializedMultiSelect"
        label="Multi-Select (initialized value)"
        options={OPTIONS}
        multiple
        allowCustom
        required
      />
      <Form.Select
        name="defaultMultiSelect"
        label="Multi-Select (default value)"
        options={OPTIONS}
        multiple
        allowCustom
        useDefault={'1,2'}
        required
      />
   </FormWrapper>
  )
}

// EXPORT
export default FormElements;
